<template>
  <div>
    <v-dialog v-model="dialog_open" max-width="400">
      <v-card>
        <v-card-text>
          <v-row align="center" class="mt-0 py-5 px-12 clinic-data-header">
            <v-col cols="12" align="center">
              ยืนยันยกเลิกการขอเอกสารหรือไม่
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" align="end">
              <v-btn
                style="size-btn"
                class="mt-0"
                color="#00a99d"
                dark
              >
                <span style="color: #FFFFFF;" class="font-14">ยืนยัน</span>
              </v-btn>
            </v-col>
            <v-col cols="6" align="start">
              <v-btn
                @click="cancle()"
                style="size-btn"
                class="mt-0"
                color="#FFFFFF"
                dark
              >
                <span style="color: #00a99d;" class="font-14">ยกเลิก</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog_open: false
  }),
  methods: {
    open () {
      this.dialog_open = true
    },
    cancle () {
      this.dialog_open = false
    }
  }
}
</script>

<style>

</style>